var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "105", height: "66", viewBox: "0 0 105 66", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Artboard"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M42.378 40.266V31.16C60.068 18.69 61.75 17.24 61.75 14.34c0-1.856-1.972-3.016-4.698-3.016-3.886 0-7.018 1.508-9.976 4.002l-6.38-7.772C45.162 2.798 51.658 1 57.052 1 67.086 1 73.64 6.568 73.64 14.34c0 5.278-3.016 9.628-13.398 15.718h13.746v10.208h-31.61z", stroke: "#2D9F86", fill: "#FFF" }),
      React.createElement("path", { d: "M102.5 63.766H2.5", stroke: "#DCF0EE", strokeWidth: "5", strokeLinecap: "square" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/number-2.svg